export default {
  label: {
    greeting: 'Olá',
    login: 'Entrar',
    item: {
      config: 'Configurações',
      createComponent: 'Criar componente',
      exit: 'Sair',
    },
  },
};
